import React from 'react';
import queryString from 'query-string';
import { Button, Form } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'alp';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    };
  }

  componentDidMount() {

    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });


    const usernameBase64 = btoa(`toolbox${this.usernameInput.value}`)
    this.props.api.userPassLogin(
      {
        username: this.usernameInput.value,
        password: this.passwordInput.value,
        usernameBase64
      }, this.parameters

    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        const translate = this.props.translate(error.errorCode);

        let message = "Senha errada. Tente novamente.";

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }
        this.setState({
          onLogin: false,
          error: { open: true, message: message },
        });
      });
  }

  render() {
    const { translate } = this.props;

    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <Form onSubmit={event => this.onSubmit(event)}>
          <div ref={this.ref}>
            <p className="site-title">Ainda mais por você</p>
            <div className="alp-divpinput">
              <label className="alp-label">Login</label>
              <input
                className="form-control-alp user-input-alp"
                disabled={this.state.onLogin}
                placeholder={translate('Seu código de assinante')}
                ref={(ref) => {
                  this.usernameInput = ref;
                }
                }
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                name="username"
              />
            </div>
            <div className="alp-divpinput">
              <label className="alp-label">Senha</label>
              <input
                className="form-control-alp user-input-alp"
                required={true}
                disabled={this.state.onLogin}
                placeholder={translate('Sua senha de acesso')}
                ref={(ref) => {
                  this.passwordInput = ref;
                }
                }
                tabIndex={1}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                name="password"
              />
            </div>
            <div className="buttons">
              <Button
                block={!this.parameters.failureRedirect}
                color="danger"
                size="lg"
                tabIndex={1}
                className="enter"
                type="submit"
                name="submit"
                disabled={!this.props.turnstileSuccess}
              >
                {translate('Entrar')}
              </Button>
              <Button
                className="back"
                href={this.parameters.failureRedirect}
                size="lg"
                id="back"
              >
                {translate('Cancelar')}
              </Button>
            </div>
            <div className="messages-container">
              {this.state.error.message}
            </div>
            <ul>

            </ul>
          </div>
        </Form>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm));
